<h1 mat-dialog-title>

    <b>Pagar Cuota Afiliado</b></h1>
<br/>
<form #pagoForm=ngForm>

    <dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Solicitante </mat-label>

                <mat-option>{{data.rutUsuario}} {{data.nombreUsuario}} {{data.apellidoUsuario}}</mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Monto  </mat-label>

                <mat-option> {{data.monto}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Mes/Año </mat-label>
                <mat-option> {{data.fechacuota}} </mat-option>

            </form-field>
        </p>      
       
            <form-field appearance="outline" class="mat-input">
                <mat-label> Adjuntar Comprobante Pago</mat-label>
                <div class="col-lg-6">
                    <input #archivo [(ngModel)]="pago.archivoTest" type="file" class="form-control-file" name="archivo" (change)="seleccionaArchivo($event,1)" required accept="application/pdf, image/jpeg, image/jpg, image/png">
                </div>

            </form-field>

    
    </dialog-content>
</form>
<br/>
<mat-dialog-actions>
    <div>
        <button mat-button class="mat-raised-button btn-success"  (click)="onAgregarPagoClick(pagoForm)">
            <i class ="fa fa-check"> </i> Aceptar
        </button>

        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
</mat-dialog-actions>

<br/>